import { render, staticRenderFns } from "./informationSellers.vue?vue&type=template&id=9bb81d3a&scoped=true"
import script from "./informationSellers.vue?vue&type=script&lang=js"
export * from "./informationSellers.vue?vue&type=script&lang=js"
import style0 from "./informationSellers.vue?vue&type=style&index=0&id=9bb81d3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb81d3a",
  null
  
)

export default component.exports